/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_IdleInputs */

const en_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idle`)
};

const fr_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactif`)
};

const de_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerlauf`)
};

const it_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oziare`)
};

const ru_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Праздный`)
};

const es_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactivo`)
};

const zh_cn2_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`闲置的`)
};

const ja_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイドル状態`)
};

const hi_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निठल्ला`)
};

const pt_pt2_live_caption_status_idle = /** @type {(inputs: Live_Caption_Status_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parado`)
};

/**
* | output |
* | --- |
* | "Idle" |
*
* @param {Live_Caption_Status_IdleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_idle = /** @type {((inputs?: Live_Caption_Status_IdleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_IdleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_status_idle(inputs)
	if (locale === "de") return de_live_caption_status_idle(inputs)
	if (locale === "it") return it_live_caption_status_idle(inputs)
	if (locale === "ru") return ru_live_caption_status_idle(inputs)
	if (locale === "es") return es_live_caption_status_idle(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_status_idle(inputs)
	if (locale === "ja") return ja_live_caption_status_idle(inputs)
	if (locale === "hi") return hi_live_caption_status_idle(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_status_idle(inputs)
	return en_live_caption_status_idle(inputs)
});